import {HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {retry, throwError, timer} from "rxjs";

const maxRetries = 2;
const retryDelay = 1000;
const retryStatusCodes = [0, 503];
const maxTotalTime = 15_000; // 10 seconds
const maxRetriesTime = 7_000; // 10 seconds

export const statusCodeRetryInterceptor: HttpInterceptorFn = (req, next) => {
  const retryRequest = (req: HttpRequest<unknown>) => {
    const startTime = Date.now();
    let retryStartTime: number | undefined;
    return next(req).pipe(
      retry({
        count: maxRetries,
        delay: (error, retryCount) => {

          if (!retryStartTime) {
            retryStartTime = Date.now();
          }
          const totalElapsedTime = Date.now() - startTime;
          const retryElapsedTime = Date.now() - retryStartTime;

          // check if the total elapsed time exceeds the max total time for either the request or the retry
          if ((totalElapsedTime > maxTotalTime) || (retryElapsedTime > maxRetriesTime)) {
            return throwError(() => error);
          }

          if (retryStatusCodes.includes(error.status)) {
            return timer(retryDelay * (retryCount * retryCount));
          }
          console.log('Retrying request', {error, retryCount});
          return throwError(() =>error);
        }
      })
    );
  };
  return retryRequest(req);

};
